import { Microfrontend } from '@cian/mf-react';

import { InfrastructureError, InfrastructureLoader } from 'shared/components/InfrastructureMap';

import { Section } from 'shared/components/Section';
import { EStatus, useMicrofrontend, useYandexApiKeys } from 'shared/hooks';
import { fetchInfrastructureMicrofrontendManifest } from 'shared/services/fetchInfrastructureMicrofrontendManifest';
import { useSelector } from 'react-redux';
import { selectHouseId } from 'shared/selectors/houseInfo';
import { FC } from 'react';

export const InfrastructureMapMicrofrontend: FC = () => {
  const houseId = useSelector(selectHouseId);

  const { manifest, fetchManifest, status } = useMicrofrontend({
    fetchFunction: fetchInfrastructureMicrofrontendManifest,
    parameters: { houseId },
    fetchOnMount: true,
  });

  const yandexApiKeys = useYandexApiKeys();

  return (
    <Section title="Расположение" bounded={false}>
      {status === EStatus.Loading && <InfrastructureLoader />}
      {status === EStatus.Error && <InfrastructureError retry={fetchManifest} />}
      {status === EStatus.Success && manifest && (
        <div data-name="InfrastructureMap">
          <Microfrontend
            name={manifest.microfrontendName}
            image={manifest.imageVersion}
            runtime={manifest.runtimeName}
            parameters={yandexApiKeys}
          />
        </div>
      )}
    </Section>
  );
};
